import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { style } from '../../utils/style.js';
import { SVG } from '../SVG.js';
import { Text } from '../Text/Text.js';
import { defaultCheckStyle } from './checkboxStyle.js';
const CHECK_PATHS = [
    {
        d: 'M10.207.793a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-2.5-2.5a1 1 0 0 1 1.414-1.414L3.5 6.086 8.793.793a1 1 0 0 1 1.414 0Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: 'white',
    },
];
export const Checkbox = JSX(({ className, value, text, disabled, isRadio, onChange }) => {
    const handleChange = useCallback((e) => {
        if (disabled) {
            return;
        }
        e.preventDefault();
        onChange && onChange(!value);
    }, [onChange, disabled, value]);
    const icon = isRadio ? (_jsx("div", { className: "absolute left-1 w-3 h-3 rounded-full bg-primary-main" })) : (_jsx(SVG, { paths: CHECK_PATHS, className: "absolute left-1 ml-px block", width: "11", height: "9", fill: "white", viewBox: "0 0 11 9" }));
    return (_jsx("div", { className: className, children: _jsxs("label", { className: style('flex items-center relative group/box', getCursorStyle(disabled)), onClick: handleChange, children: [_jsx("div", { className: style(defaultCheckStyle, 'm-0', isRadio ? 'rounded-full border-2' : checkboxStyle(value), !disabled && value ? 'border-primary-main' : 'border-gray', disabled ? 'bg-main-disabled' : 'group-hover/box:border-primary-hover'), role: role(isRadio), "aria-checked": Boolean(value), "aria-disabled": Boolean(disabled), "aria-label": text }), value ? icon : null, renderText(text)] }) }));
});
const renderText = (text) => text ? (_jsx("div", { className: "ml-s", children: _jsx(Text, { size: "text-l", font: "font-light", children: text }) })) : null;
const getCursorStyle = (disabled = false) => (disabled ? 'cursor-not-allowed' : 'cursor-pointer');
const role = (isRadio = false) => (isRadio ? 'radio' : 'checkbox');
const checkboxStyle = (value = false) => style('rounded border', { 'bg-primary-main': value });
//# sourceMappingURL=Checkbox.js.map